"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu May 09 2019
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var SimulationValue_1 = require("./SimulationValue");
/**
 * @author BPo
 */


var SimulationString =
/*#__PURE__*/
function (_SimulationValue_1$Si) {
  _inherits(SimulationString, _SimulationValue_1$Si);

  function SimulationString() {
    _classCallCheck(this, SimulationString);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulationString).apply(this, arguments));
  }

  _createClass(SimulationString, null, [{
    key: "fromSimulatedValue",
    value: function fromSimulatedValue(value) {
      return new SimulationString(value, null, null, null);
    }
    /**
     * Converter from data-dictionary representation
     */

  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SimulationString(mat.simulatedValue, mat.originalValue, mat.note, mat.accepted);
    }
  }]);

  return SimulationString;
}(SimulationValue_1.SimulationValue);

exports.SimulationString = SimulationString;

SimulationString.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimulationString.name);
  return {
    simulatedValue: builder.str('simulatedValue'),
    originalValue: builder.opt(builder.str('originalValue')),
    note: builder.opt(builder.str('note')),
    accepted: builder.opt(builder.bool('accepted'))
  };
}();